import { utils } from 'components/lexemes';
import Localization from 'lib/localization';

export default {
  tab: {
    title() {
      return Localization.get('bumblesite@privacy.informationDisclosure.tab.title');
    },
    text() {
      return Localization.get('bumblesite@privacy.informationDisclosure.tab.description');
    },
    contents: {
      title() {
        return Localization.get('bumblesite@privacy.informationDisclosure.tab.contents.title');
      },
      item1() {
        return Localization.get('bumblesite@privacy.informationDisclosure.tab.contents.item1');
      },
      item2() {
        return Localization.get('bumblesite@privacy.informationDisclosure.tab.contents.item2');
      },
    },
  },
  subsection1: {
    intro1() {
      return Localization.get('bumblesite@privacy.informationDisclosure.subsection1.intro1');
    },
    intro2() {
      return Localization.get('bumblesite@privacy.informationDisclosure.subsection1.intro2');
    },
    title() {
      return Localization.get('bumblesite@privacy.informationDisclosure.subsection1.title');
    },
    column1() {
      return Localization.get('bumblesite@privacy.informationDisclosure.subsection1.column1');
    },
    column2() {
      return Localization.get('bumblesite@privacy.informationDisclosure.subsection1.column2');
    },
    goodToKnow: {
      title() {
        return Localization.get('bumblesite@privacy.takeControlOfYourData');
      },
      content() {
        return Localization.get('bumblesite@privacy.informationDisclosure.subsection1.tip.content');
      },
    },
  },
  subsection2: {
    title() {
      return Localization.get('bumblesite@privacy.informationDisclosure.subsection2.title');
    },
    text1() {
      return Localization.get('bumblesite@privacy.informationDisclosure.subsection2.text1');
    },
    text2() {
      return Localization.get('bumblesite@privacy.informationDisclosure.subsection2.text2');
    },
    subTitle() {
      return Localization.get('bumblesite@privacy.informationDisclosure.subsection2.subTitle');
    },
    text3() {
      return Localization.get('bumblesite@privacy.informationDisclosure.subsection2.text3', {
        link_bff_steps_to_object_bff_mode: utils.getLinkMarkerUrl(
          'link_bff_steps_to_object_bff_mode',
        ),
      });
    },
  },
};
